var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _vm.isAdmin()
          ? _c(
              "div",
              { staticClass: "col-md-2 mb-3" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: "/admin/organizations/create" },
                  },
                  [_vm._v("\n                Create\n            ")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-10" }, [
          _c("div", { staticClass: "control has-icons-left w-100" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.listStore.query,
                  expression: "listStore.query",
                },
              ],
              staticClass: "form-control border-primary",
              attrs: {
                type: "text",
                placeholder: "Enter a keyword",
                autocomplete: "off",
                autofocus: "",
              },
              domProps: { value: _vm.listStore.query },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.listStore, "query", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-12 my-3",
            staticStyle: {
              display: "flex",
              "align-items": "center",
              gap: "8px",
            },
          },
          [
            _vm._v(
              "\n            View unpublished organizations\n            "
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.listStore.privateOrgs,
                  expression: "listStore.privateOrgs",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.listStore.privateOrgs)
                  ? _vm._i(_vm.listStore.privateOrgs, null) > -1
                  : _vm.listStore.privateOrgs,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.listStore.privateOrgs,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.listStore,
                          "privateOrgs",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.listStore,
                          "privateOrgs",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.listStore, "privateOrgs", $$c)
                  }
                },
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading: _vm.listStore.isLoading,
            failed: _vm.listStore.failed,
          },
          on: { retry: _vm.listStore.reload },
        },
        [
          _c(
            "div",
            {
              staticClass: "table-responsive",
              staticStyle: { "padding-bottom": "20px" },
            },
            [
              _c("table", { staticClass: "table table-hover mb-0" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Organization Name")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Updated At")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Actions")]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(
                      _vm.organizationCollectionStore.items,
                      function (organization) {
                        return _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "navi-link",
                                  attrs: {
                                    to: _vm.getOrganizationUrl(organization),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(organization.organizationName) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toLocaleDateTimeString")(
                                  organization.updatedAt
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "MoreActions",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: {
                                        to: _vm.getOrganizationUrl(
                                          organization
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    View\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      }
                    ),
                    _vm._v(" "),
                    _vm.listStore.noRecords ? _c("NoRecords") : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("v-pagination", {
        attrs: {
          pageCount: _vm.organizationCollectionStore.pageCount,
          value: _vm.organizationCollectionStore.page,
        },
        on: { input: _vm.organizationCollectionStore.changePage },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "fas fa-search" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }